// extracted by mini-css-extract-plugin
export var hideScrollContainers = "VbXNP";
export var mailListShimmerStateContainer = "fqEuY";